<template>
  <div class="crud-area">
    <div class="container-fluid">
      <div
        class="crud-header d-flex justify-content-between align-items-center mb-4"
      >
        <div>
          <h2 class="crud-title">Estrutura Orgânica</h2>
          <p class="crud-subtitle">
            Gerir os membros da estrutura orgânica da fundação
          </p>
        </div>
        <button class="btn-primary-grad" @click="openCreate">
          <i class="ri-add-line"></i> Novo Membro
        </button>
      </div>

      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary"></div>
      </div>
      <div v-if="error" class="alert-error mb-3">
        <i class="ri-error-warning-line"></i> {{ error }}
      </div>

      <div v-if="!loading" class="crud-card">
        <div class="table-responsive">
          <table class="crud-table">
            <thead>
              <tr>
                <th>Foto</th>
                <th>Nome</th>
                <th>Cargo (PT)</th>
                <th>Ordem</th>
                <th class="text-end">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="items.length === 0">
                <td colspan="5" class="text-center text-muted py-4">
                  Sem membros registados.
                </td>
              </tr>
              <tr v-for="item in items" :key="item.id">
                <td>
                  <img
                    :src="
                      item.imageUrl ||
                      require('../../assets/images/avatar/avatar-1.jpg')
                    "
                    class="avatar-sm rounded-circle"
                    alt="Foto"
                  />
                </td>
                <td>{{ item.name }}</td>
                <td>{{ item.position_pt }}</td>
                <td>{{ item.order }}</td>
                <td class="text-end">
                  <button class="btn-icon edit" @click="openEdit(item)">
                    <i class="ri-edit-line"></i>
                  </button>
                  <button class="btn-icon delete" @click="confirmDelete(item)">
                    <i class="ri-delete-bin-line"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Modal Criar / Editar -->
    <div v-if="showModal" class="crud-modal-overlay" @click.self="closeModal">
      <div class="crud-modal">
        <div class="crud-modal-header">
          <h3>{{ editing ? "Editar Membro" : "Novo Membro" }}</h3>
          <button class="btn-close-modal" @click="closeModal">
            <i class="ri-close-line"></i>
          </button>
        </div>
        <form @submit.prevent="save" class="crud-modal-body">
          <div class="row g-3">
            <div class="col-12">
              <label>Nome *</label>
              <input
                v-model="form.name"
                class="form-input"
                required
                placeholder="Ex: João Silva"
              />
            </div>
            <div class="col-12">
              <label>Cargo (PT) *</label>
              <input
                v-model="form.position_pt"
                class="form-input"
                required
                placeholder="Ex: Presidente"
              />
            </div>
            <div class="col-12">
              <label>Cargo (EN)</label>
              <input
                v-model="form.position_en"
                class="form-input"
                placeholder="Ex: President"
              />
            </div>
            <div class="col-12">
              <label>Biografia / CV (PT)</label>
              <textarea
                v-model="form.description_pt"
                class="form-input"
                rows="4"
                placeholder="Breve currículo ou biografia em português"
              ></textarea>
            </div>
            <div class="col-12">
              <label>Biografia / CV (EN)</label>
              <textarea
                v-model="form.description_en"
                class="form-input"
                rows="4"
                placeholder="Short CV or biography in English"
              ></textarea>
            </div>
            <div class="col-6">
              <label>Ordem de Exibição</label>
              <input
                v-model.number="form.order"
                type="number"
                class="form-input"
                placeholder="0"
              />
            </div>
            <div class="col-12">
              <label>Foto *</label>
              <ImageUpload
                :value="form.imageUrl"
                @update:value="form.imageUrl = $event"
                @uploading="imageUploading = $event"
                accept="image/*"
                acceptLabel="Apenas imagens (JPG, PNG, WebP)"
                label="Carregar foto do membro"
                :hideYoutube="true"
              />
            </div>
          </div>
          <div class="crud-modal-footer mt-4">
            <button type="button" class="btn-secondary" @click="closeModal">
              Cancelar
            </button>
            <button
              type="submit"
              class="btn-primary-grad"
              :disabled="saving || imageUploading"
            >
              <span v-if="saving"
                ><i class="ri-loader-4-line spin"></i> A guardar...</span
              >
              <span v-else-if="imageUploading"
                ><i class="ri-loader-4-line spin"></i> Upload em curso...</span
              >
              <span v-else>{{ editing ? "Guardar" : "Criar" }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Confirmação de Eliminar -->
    <div
      v-if="showDelete"
      class="crud-modal-overlay"
      @click.self="showDelete = false"
    >
      <div class="crud-modal crud-modal--sm">
        <div class="crud-modal-header">
          <h3>Eliminar Membro</h3>
          <button class="btn-close-modal" @click="showDelete = false">
            <i class="ri-close-line"></i>
          </button>
        </div>
        <div class="crud-modal-body">
          <p>
            Tem a certeza que quer eliminar
            <strong>{{ selectedItem?.name }}</strong
            >?
          </p>
        </div>
        <div class="crud-modal-footer">
          <button class="btn-secondary" @click="showDelete = false">
            Cancelar
          </button>
          <button class="btn-danger" @click="deleteItem" :disabled="saving">
            Eliminar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import organicStructureService from "../../services/organicStructureService";
import ImageUpload from "../Common/ImageUpload.vue";

export default {
  name: "OrganicStructureContent",
  components: { ImageUpload },
  data() {
    return {
      items: [],
      loading: true,
      saving: false,
      error: "",
      showModal: false,
      showDelete: false,
      editing: false,
      imageUploading: false,
      selectedItem: null,
      form: {
        name: "",
        position_pt: "",
        position_en: "",
        description_pt: "",
        description_en: "",
        imageUrl: "",
        order: 0,
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = "";
      try {
        this.items = await organicStructureService.getAll();
      } catch {
        this.error = "Erro ao carregar estrutura orgânica.";
      } finally {
        this.loading = false;
      }
    },
    openCreate() {
      this.editing = false;
      this.form = {
        name: "",
        position_pt: "",
        position_en: "",
        description_pt: "",
        description_en: "",
        imageUrl: "",
        order: 0,
      };
      this.showModal = true;
    },
    openEdit(item) {
      this.editing = true;
      this.selectedItem = item;
      this.form = { ...item };
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    async save() {
      if (!this.form.imageUrl) {
        this.error = "A foto do membro é obrigatória.";
        return;
      }
      this.saving = true;
      this.error = "";
      try {
        const payload = {
          name: this.form.name,
          position_pt: this.form.position_pt,
          position_en: this.form.position_en || null,
          description_pt: this.form.description_pt || null,
          description_en: this.form.description_en || null,
          imageUrl: this.form.imageUrl,
          order: parseInt(this.form.order) || 0,
        };

        if (this.editing) {
          await organicStructureService.update(this.selectedItem.id, payload);
        } else {
          await organicStructureService.create(payload);
        }
        this.closeModal();
        this.load();
      } catch (e) {
        this.error = "Erro ao guardar membro. Verifique os dados.";
        console.error(e);
      } finally {
        this.saving = false;
      }
    },
    confirmDelete(item) {
      this.selectedItem = item;
      this.showDelete = true;
    },
    async deleteItem() {
      this.saving = true;
      try {
        await organicStructureService.remove(this.selectedItem.id);
        this.showDelete = false;
        this.load();
      } catch {
        this.error = "Erro ao eliminar membro.";
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../Dashboards/GgmfDashboard/ggmf-card";

.avatar-sm {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
</style>
